import { render, staticRenderFns } from "./AppDevelopmentDetails.vue?vue&type=template&id=0a3735f4&"
import script from "./AppDevelopmentDetails.vue?vue&type=script&lang=js&"
export * from "./AppDevelopmentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports